interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  /** Tighter row for fixed footers (no top margin, smaller controls). */
  compact?: boolean;
}

export function Pagination({ page, totalPages, onPageChange, compact }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-between w-full ${compact ? 'min-h-0' : 'mt-4'}`}>
      <div
        className={`flex items-center gap-1 ${compact ? 'text-xs h-8' : 'text-sm'}`}
      >
        <span className="font-medium text-text-secondary">Page</span>
        <span className="font-medium text-text-primary">{page}</span>
        <span className="font-medium text-text-secondary">of</span>
        <span className="font-medium text-text-brand">{totalPages}</span>
      </div>

      <div className={compact ? 'flex items-center gap-1.5' : 'flex items-center gap-3'}>
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className={
            compact
              ? 'h-8 px-2.5 bg-white border border-border-primary rounded-md text-xs font-medium shadow-sm disabled:text-text-disabled disabled:cursor-not-allowed text-text-primary hover:bg-surface-secondary transition leading-none'
              : 'h-10 px-3.5 py-2.5 bg-white border border-border-primary rounded-lg text-sm font-medium shadow-sm disabled:text-text-disabled disabled:cursor-not-allowed text-text-primary hover:bg-surface-secondary transition'
          }
        >
          Previous
        </button>
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className={
            compact
              ? 'h-8 px-2.5 bg-white border border-border-primary rounded-md text-xs font-medium shadow-sm disabled:text-text-disabled disabled:cursor-not-allowed text-text-primary hover:bg-surface-secondary transition leading-none'
              : 'h-10 px-3.5 py-2.5 bg-white border border-border-primary rounded-lg text-sm font-medium shadow-sm disabled:text-text-disabled disabled:cursor-not-allowed text-text-primary hover:bg-surface-secondary transition'
          }
        >
          Next
        </button>
      </div>
    </div>
  );
}
